
<div class="ui modal" id="Message_Modal">

  <div class="header" style="background-color:#DCDCDC">
    <span id="Message_Modal_Header">{{this.tournamentsService.Message_Modal_Header}}</span>
    <button style="float:right;background-color: white;border: 1px solid;" class="circular ui icon button" (click)="Message_Modal_Close()">
      <i class="remove link icon"></i>
    </button>
  </div>

  <div class="content" style="height:180px;">
    <span id="Message_Modal_Desc" style="font-size: 18px;">{{this.tournamentsService.Message_Modal_Desc}}</span>
  </div>
</div>